import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import _ from "lodash";
import UnitsRow from "./UnitsRow";
import { OrderedType } from "./Units";

export default class ButtonsBlock extends PureComponent {
  static propTypes = {
    onSelectedUnit: PropTypes.func.isRequired,
    unitOfMeasurements: PropTypes.array,
    userUnits: PropTypes.object
  };

  static defaultProps = {
    unitOfMeasurements: [],
    userUnits: {}
  };

  handleSelectedUnit = (unit, type) => this.props.onSelectedUnit(unit, type);

  render() {
    const { unitOfMeasurements, userUnits } = this.props;
    const unitByType = _.groupBy(unitOfMeasurements, "type");
    const orderedTypes = Object.values(OrderedType);

    return (
      <table className="units-of-measure__table">
        <tbody>
          {!_.isEmpty(unitByType) &&
            _.sortBy(Object.keys(unitByType), type => orderedTypes.indexOf(type)).map(type => {
              return (
                <tr className="units-row" key={type}>
                  <UnitsRow type={type} unitOfMeasurements={unitOfMeasurements} onSelectedUnit={this.handleSelectedUnit} userUnits={userUnits} />
                </tr>
              );
            })}
        </tbody>
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/UnitsSelector/ButtonsBlock.js